import React from 'react'
import PropTypes from 'prop-types'
import * as Icons from 'ui/icons'

function AddActionButton ({ children, onClick }) {
  const classNames = [
    'add-action-button',
    'rounded-lg',
    'relative',
    'border',
    'border-transparent',
    'text-gray-600',
    'w-full',
    'focus:outline-none',
    'focus:bg-white',
    'focus:bg-opacity-50',
    'transition-colors',
    'ease-in',
    'duration-300',
    'hover:text-primary-500',
    'px-3',
    'py-6',
    'xl:px-4',
    'xl:py-9'
  ]

  return (
    <button onClick={onClick} className={classNames.join(' ')}>
      <div className='absolute top-0 left-0 right-0 bottom-0 border-2 border-dashed border-gray-300 rounded-lg hover:border-primary-500' />

      <div className='text-center text-sm xl:text-base'>
        <Icons.PlusCircle className='w-4 h-4 mx-auto mb-2' />
        {children}
      </div>
    </button>
  )
}

AddActionButton.defaultProps = {
  onClick: null
}

AddActionButton.propTypes = {
  /**
     * OnClick event handler
     */
  onClick: PropTypes.func
}

export default AddActionButton
